import React from 'react';
import OfficerCard from './OfficerCard';
import './Officers.css';
import { officers } from '../content';

const Officers = () => {
  return (
    <section className="fade-in" id="officers">

      {/* Hero Image with Title */}
      <div className="officers-image">
        <img src="/images/officers.jpg" alt="Officers" />
        <div className="hero-text content-wrapper">
          <h1 className="title">Officers</h1>
          <p className="description">
            Hover over the images to learn about each officer!
          </p>
        </div>
      </div>

      {/* Officer Cards Grid */}
      <div className="officer-grid">
        {officers.map((officer) => (
          <OfficerCard
            key={officer.id}
            image={officer.image}
            name={officer.name}
            title={officer.title}
            description={officer.description}
          />
        ))}
      </div>
    </section>
  );
};

export default Officers;
